<template>
  <v-sheet class="pa-2 ma-2">
    <v-sheet class="mt-2 mb-2">
      <TipTapReader style="min-height: 700px" class="tiptap_style pa-2" :options="options" v-if="options.content" :key="componentKey" />
    </v-sheet>
    <v-sheet v-if="$store.state.type == '관리자'">
      <v-sheet class="d-flex justify-center pa-1">
        <v-btn outlined class="px-10" color="orange" @click="update()"> 수정하기 (관리자) </v-btn>
      </v-sheet>
    </v-sheet>
  </v-sheet>
</template>
<script>
import TipTapReader from "@/components/tiptap/Reader"
import htmlServce from "@/api/html-service"
import { mapState } from "vuex"

export default {
  props: ["title"],

  components: {
    TipTapReader,
  },

  computed: {
    ...mapState(["lang"]),
  },

  watch: {
    lang: function (val) {
      this.options.content = this.getContent()
      this.componentKey += 1
    },
  },

  data: () => ({
    componentKey: 0,
    htmlResource: null,

    //TipTap
    options: {
      content: "",
      editable: false,
      supportImage: true,
      supportVideo: true,
    },
  }),

  mounted() {
    htmlServce
      .getHtmlBlobData(this.title)
      .then((res) => {
        if (res) {
          //this.options.content = res.content
          this.htmlResource = res
          this.options.content = this.getContent()
          this.componentKey += 1
        }
      })
      .catch((e) => {
        console.log(e)
        alert(this.$t("alert.error_failed_get_information"))
      })
  },

  methods: {
    update() {
      this.$router.push("/policy/" + this.title + "?type=write")
    },
    getContent() {
      if (!this.htmlResource) {
        return ""
      }
      switch (this.lang) {
        case "jp":
          return this.htmlResource.content_jp || this.htmlResource.content
        case "en":
          return this.htmlResource.content_en || this.htmlResource.content
        default:
          return this.htmlResource.content
      }
    },
  },
}
</script>
